<template>
  <div>
    <template>
      <el-input
        :value="value"
        @input="change($event)"
        :disabled="item.disabled"
        :readonly="item.readonly"
        :placeholder="item.placeholder"
        :maxlength="item.maxLength"
        clearable
        @focus="focus($event)"
        class="sr-input"
        v-bind="item"
      >
        <el-button
          :slot="item.append ? 'append' : false"
          :icon="item.icon ? item.icon : 'el-icon-search'"
          @click="search"
        ></el-button>
      </el-input>
    </template>
  </div>
</template>

<!--
  功能：下拉框组件
  汪振涛
  时间：2020年11月19日 17:09:02
  版本：v1.0
-->
<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  name: "SrInput",
  components: {},
  props: {
    value: String | Number,
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    },
    search() {
      this.$emit("search");
    },
    focus() {
      this.$emit("focus");
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrInput/SrInput.vue